import type { Getter, Setter } from 'jotai';
import type { OutputRelationshipT } from '../../../../../modernization-common/relationships';
import type { UndoRedoActionCommand } from '../../../../../modernization-common/undo-redo/types';
import { applyFrameRangeDeletion } from '../../../utils/relationships-utils';
import { relationshipStoreAtom } from '../../relationship-atoms';
import type { DeleteRelationshipEventPayload } from '../events';
export const deleteRelationshipCommandFactory = (get: Getter, set: Setter): UndoRedoActionCommand<DeleteRelationshipEventPayload, void> => {
  let previousRelationships: Record<string, OutputRelationshipT> = {};
  let createdIds: string[] = [];
  return {
    execute: payload => {
      previousRelationships = {};
      createdIds = [];
      const store = get(relationshipStoreAtom);
      if (!payload.frameRange) {
        for (const id of payload.relationshipIds) {
          const rel = store[id];
          if (rel) previousRelationships[id] = rel;
        }
        const updatedStore = {
          ...store
        };
        for (const id of payload.relationshipIds) delete updatedStore[id];
        set(relationshipStoreAtom, updatedStore);
      } else {
        const result = applyFrameRangeDeletion(store, payload.relationshipIds, payload.frameRange);
        previousRelationships = result.previousSnapshot;
        createdIds = result.createdIds;
        set(relationshipStoreAtom, result.updatedStore);
      }
    },
    undo: () => {
      set(relationshipStoreAtom, prev => {
        const next = {
          ...prev
        };
        for (const id of createdIds) delete next[id];
        return {
          ...next,
          ...previousRelationships
        };
      });
    }
  };
};